import { createContext } from 'react'

export type SourceEntry = { id: string; text: string }
export const SourceListContext = createContext<SourceEntry[]>([])
